export default {
  pages: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  pageContent: {
    loading: {},
    lastUpdate: {},
    data: {},
  },
  filters: {
    loading: false,
    lastUpdate: null,
    data: [],
    filtersValues: {},
  },
  analysisBi: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  modeloServirOverview: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  modeloServirProductivity: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  modeloServirIndividual: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  filtroModeloServir: {},
  // {{NEXT}}
}
